export default __webpack_public_path__ + "static/media/uolhos.cec030ba.svg";